import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import API from '../../api';
import { useToast } from '../../context/ToastContext';
import SearchSelect from '../../components/SearchSelect';

export default function EtudiantSoumissions() {
  const [evals, setEvals] = useState([]);
  const [selectedEval, setSelectedEval] = useState('');
  const [copies, setCopies] = useState([]);
  const [fichier, setFichier] = useState(null);
  const { addToast } = useToast();
  const location = useLocation();

  useEffect(() => {
    API.get('evaluations/').then((r) => {
      const all = r.data.results || r.data;
      const nonQcm = all.filter((e) => e.type_eval !== 'QCM');
      setEvals(nonQcm);
      // Auto-sélection si on vient de la page évaluations
      const fromState = location.state?.evaluationId;
      if (fromState && nonQcm.some((e) => String(e.id) === String(fromState))) {
        setSelectedEval(String(fromState));
      }
    });
  }, [location.state]);

  useEffect(() => {
    if (!selectedEval) return;
    API.get(`copies/?evaluation=${selectedEval}`).then((r) => setCopies(r.data.results || r.data));
  }, [selectedEval]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!fichier || !selectedEval) return;
    const fd = new FormData();
    fd.append('evaluation', selectedEval);
    fd.append('fichier', fichier);
    try {
      await API.post('copies/', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      addToast('Copie soumise avec succès !', 'success');
      setFichier(null);
      e.target.reset();
      API.get(`copies/?evaluation=${selectedEval}`).then((r) => setCopies(r.data.results || r.data));
    } catch (err) {
      const detail = err.response?.data?.detail || err.response?.data?.non_field_errors?.[0] || 'Erreur lors de la soumission.';
      addToast(detail, 'error');
    }
  };

  const existingCopy = copies.length > 0;

  return (
    <div>
      <div className="page-header">
        <h2><i className="bi bi-cloud-upload" /> Soumettre une copie</h2>
      </div>

      <SearchSelect
        className="select-filter-wrap"
        value={selectedEval}
        onChange={(e) => { setSelectedEval(e.target.value); }}
        options={evals.map((ev) => ({ value: ev.id, label: `${ev.titre} (${ev.type_eval}) – ${ev.cours_titre}` }))}
        placeholder="-- Sélectionner une évaluation --"
      />

      {selectedEval && (
        <>
          {existingCopy ? (
            <div className="glass-card-static">
              <h3><i className="bi bi-check-circle" style={{ color: 'var(--success)' }} /> Copie déjà soumise</h3>
              <p style={{ color: 'var(--text-secondary)', fontSize: 14 }}>Vous avez déjà soumis une copie pour cette évaluation.</p>
              {copies.map((c) => (
                <div key={c.id} className="support-item">
                  <span><i className="bi bi-file-earmark-check" /> Soumise le {new Date(c.soumis_le).toLocaleString('fr-FR')}</span>
                  {(c.fichier_url || c.fichier) && (
                    <a href={c.fichier_url || c.fichier} target="_blank" rel="noreferrer" className="btn btn-sm btn-secondary"><i className="bi bi-eye" /> Voir</a>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div className="form-glass">
              <h3><i className="bi bi-upload" /> Déposer votre copie</h3>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Fichier</label>
                  <input className="form-control" type="file" onChange={(e) => setFichier(e.target.files[0])} required />
                </div>
                <div className="form-actions">
                  <button type="submit" className="btn btn-primary"><i className="bi bi-cloud-upload" /> Soumettre</button>
                </div>
              </form>
            </div>
          )}
        </>
      )}
    </div>
  );
}
